import http from './http'

export default {
    all() {
        return http.get('cobranzas')
    },

    create(payload) {
        return http.post('cobranzas', payload)
    },

    get(cobranza) {
        return http.get(`cobranzas/${cobranza}`)
    },

    update(cobranza, payload) {
        return http.put(`cobranzas/${cobranza}`, payload)
    }
}